module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/connection-tv.a91e3fd3.mp4";